export const apiEndpoints = Object.freeze({
    auth: {
        base: '/auth',
        signup: '/auth/signup',
        signin: '/auth/signin',
        refreshToken: '/auth/refresh-token',
    },
    user: {
        base: '/user',
        getAll: '/user/all',
        create: '/user/create',
        update: (id: string) => `/user/${id}`,
        delete: (id: string) => `/user/${id}`,
    },
    booking: {
        base: '/booking',
        list: '/booking/list',
        create: '/booking/create',
        manualCreate: '/booking/manual-create',
        byId: (id: string) => `/booking/${id}`,
        byShowId: (showId: string) => `/booking/${showId}`,
        byShortId: (shortId: string) => `/booking/short_id/${shortId}`,
        updateStatus: (id: string) => `/booking/${id}`,
        update: (id: string) => `/booking/${id}`,
        cancel: (id: string) => `/booking/cancel/${id}`,
        delete: (id: string) => `/booking/${id}`,
        dateRange: '/booking/date-range',
        checkIn: (id: string, token: string) => `/booking/${id}/check-in/${token}`,
        import: '/booking/import',
        jobStatus: (jobId: string) => `/booking/job/${jobId}`,
        deletePayment: (id: string) => `/booking/payment/delete/${id}`,
    },
    show: {
        base: '/show',
        create: '/show/create',
        byId: (id: string) => `/show/${id}`,
        dateRange: '/show/date-range',
        update: (id: string) => `/show/update/${id}`,
        markFull: (id: string) => `/show/mark-full/${id}`,
        updateCapacity: (id: string) => `/show/capacity/${id}`,
        updateGlobalCapacity: '/show/global-capacity',
        calendar: (year: string, month: string) => `/show/calendar/${year}/${month}`,
        delete: (id: string) => `/show/${id}`,
        createMonthlyDefaultShows: '/show/create-monthly-default',
        availability: '/show/availability',
        initializeHistorical: '/show/initialize-historical',
        resetAvailabilities: '/show/reset-availabilities',
        jobStatus: (jobId: string) => `/show/job/${jobId}`,
        recalibrateTimes: '/show/recalibrate-times',
        syncCapacityManual: '/show/sync-capacity-manual',
        syncCapacityById: (id: string) => `/show/${id}/sync-capacity`,
    },
    seat: {
        base: '/seat',
        create: '/seat/create',
        list: '/seat/list',
        byId: (id: string) => `/seat/${id}`,
        byShowId: (showId: string) => `/seat/show/${showId}`,
        availableByShowId: (showId: string) => `/seat/available/${showId}`,
        updateStatus: (id: string) => `/seat/status/${id}`,
        update: (id: string) => `/seat/${id}`,
        book: (id: string) => `/seat/book/${id}`,
        delete: (id: string) => `/seat/${id}`,
    },
    setting: {
        base: '/settings',
        create: '/settings',
        all: '/settings',
        byCategory: (category: string) => `/settings/category/${category}`,
        byKey: (key: string) => `/settings/${key}`,
        update: (key: string) => `/settings/${key}`,
    },
    theater: {
        base: '/theater',
        create: '/theater/create',
        all: '/theater/all',
        byId: (id: string) => `/theater/${id}`,
        byLocation: (location: string) => `/theater/location/${location}`,
        byName: (name: string) => `/theater/name/${name}`,
    },
    payment: {
        base: '/payment',
        create: '/payment/create',
        verify: '/payment/verify',
    },
    public: {
        base: '/public',
        booking: '/public/booking',
        availability: '/public/availability',
        settings: '/public/settings',
        sendEmail: '/public/send-email',
        validatePromoCode: '/public/promocode/validate',
        createLog: '/public/log',
    },
    promocode: {
        base: '/promocode',
        create: '/promocode/create',
        all: '/promocode/all',
        byId: (id: string) => `/promocode/${id}`,
        emailCustomer: (id: string) => `/promocode/${id}/email`,
    },
    logs: {
        list: '/logs/list',
        create: '/logs/create',
        clear: '/logs/clear'
    },
    errorLogs: {
        list: '/error-logs',
        dismiss: (id: string) => `/error-logs/${id}/dismiss`,
        dismissAll: '/error-logs/dismiss-all'
    },
    backup: {
        start: '/backup/atlas/start',
        status: (jobId: string) => `/backup/atlas/status/${jobId}`,
        collections: '/backup/atlas/collections'
    }
});